import {
  SET_EDIT_ROW_MAIN_DATA,
  OPEN_DESIGNER_SIDEBAR,
  CLOSE_DESIGNER_SIDEBAR,
  SET_ADDITIONAL_DESIGNER_DATA,
  RESET_EDIT_ROW_FORM,
  SET_EDIT_ROW_SECTIONS_MODAL_STATE,
  SET_MOUSE_COORDS,
  SET_DND_SECTION_ID,
  UPDATE_CURRENT_LAYOUT,
  SET_PARENT_REFS,
  UPDATE_CURRENT_LAYOUT_LIST,
  RESET_DND_SECTION_ID,
  ADD_TO_UNRELATED_FIELDS,
  REMOVE_FROM_UNRELATED_FIELDS,
  SET_ADD_NEW_SECTION_MODAL_STATE,
  ADD_NEW_SECTION,
  MOVE_ITEM_TO_SECTION,
  DELETE_SECTION,
  SET_SECTION_REORDER_MODAL_STATE,
  SAVE_SECTIONS_ORDERING,
  SET_CUSTOMISATION_MODAL_STATE,
  UPDATE_SECTION,
  SET_SEARCH_VALUE,
  UPDATE_UNRELATED_FIELDS,
  REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS,
  UPDATE_MODEL,
  UPDATE_DATA_IN_EDIT_MODE,
} from '@/store/modules/designer/mutation-types';
import {uuid} from 'vue-uuid';


export default {
  [SET_EDIT_ROW_MAIN_DATA](state, payload) {
    const {mainData, relatedFields, placeholders} = payload;
    state.copySections = mainData.Sections;
    state.data = mainData;
    state.relatedFields = relatedFields;
    state.placeholders = placeholders;
  },
  [OPEN_DESIGNER_SIDEBAR](state) {
    state.isDesignerSidebarOpened = true;
  },
  [CLOSE_DESIGNER_SIDEBAR](state) {
    state.isDesignerSidebarOpened = false;
  },
  [SET_ADDITIONAL_DESIGNER_DATA](state, payload) {
    const {form, fields, unrelatedFields} = payload;
    state.form = form;
    state.fields = fields;
    state.unrelatedFields = unrelatedFields;
  },
  [SET_EDIT_ROW_SECTIONS_MODAL_STATE](state, payload) {
    const {show, isEditMode, item} = payload;
    state.isModalOpened = show;
    state.isEditMode = isEditMode;
    state.item = item;
  },
  [RESET_EDIT_ROW_FORM](state, payload) {
    state.form = payload;
  },
  [SET_MOUSE_COORDS](state, payload) {
    state.mouseXY = payload;
  },
  [SET_DND_SECTION_ID](state, uuid) {
    state.dndSectionId = uuid;
  },
  [RESET_DND_SECTION_ID](state) {
    state.dndSectionId = null;
  },
  [UPDATE_CURRENT_LAYOUT](state, payload) {
    const layout = state.data.Sections.map(el => {
      if (payload.layoutId === el.id) {
        el.Fields.push(payload.newLayoutItem);
        return el;
      }
      return el;
    });
    state.data = {...state.data, Sections: layout};
  },
  [SET_PARENT_REFS](state, refs) {
    state.parentRefs = refs;
  },
  [UPDATE_CURRENT_LAYOUT_LIST](state, payload) {
    const {id, list} = payload;
    const res = state.data.Sections.map(el => {
      if (el.id === id) {
        el.Fields = list.map((el, idx) => ({
          ...el,
          i: idx.toString(),
        }));
        return el;
      }
      return el;
    });
    state.data = {...state.data, Sections: res};
  },
  [REMOVE_FROM_UNRELATED_FIELDS](state, uuid) {
    state.unrelatedFields = state.unrelatedFields.filter(el => el.fieldGuid !== uuid);
  },
  [ADD_TO_UNRELATED_FIELDS](state, payload) {
    const {fieldUuid, layoutId} = payload;

    const sections = state.data.Sections.map(section => {
      if (section.id === layoutId) {
        const Fields = section.Fields.filter(el => el.fieldGuid.toLowerCase() !== fieldUuid);
        return {...section, Fields};
      }
      return section;
    });

    const deletedField = state.fields[fieldUuid];
    state.unrelatedFields.push(deletedField);

    state.data = {...state.data, Sections: sections};
  },
  [SET_ADD_NEW_SECTION_MODAL_STATE](state, payload) {
    if (payload.isEditMode) {
      const section = state.data.Sections.find(s => s.id === payload.sectionId);
      state.addEditSectionModal = {
        sectionName: section.Name,
        sectionId: payload.sectionId,
        isOpen: payload.isOpen,
        isEditMode: payload.isEditMode,
      };
    } else {
      state.addEditSectionModal = payload;
    }
  },
  [ADD_NEW_SECTION](state, payload) {
    const {name, isHidden} = payload;
    const id = uuid.v4();
    state.placeholders.push(id);
    state.data.Sections.push({
      Name: name.length ? name : `Placeholder ${state.placeholders.findIndex(el => el === id) + 1}`,
      Fields: [],
      id: uuid.v4(),
      Placeholder: !name.length,
      isHidden: isHidden,
    });
  },
  [MOVE_ITEM_TO_SECTION](state, payload) {
    const getSection = (id) => {
      return state.data.Sections.find(el => el.id === id);
    };
    const generateNewItem = (field, fieldsLength) => {
      return {
        ...field,
        x: 0,
        y: 0,
        moved: false,
        w: 4,
        h: 1,
        i: toSection.Fields.length.toString(),
      };
    };
    const toSection = getSection(payload.toSectionId);

    if (payload.fromSectionId) {
      state.data.Sections = state.data.Sections.map(section => {
        if (section.id === payload.fromSectionId) {
          section.Fields = section.Fields.filter(field => {
            if (field.fieldGuid === payload.fieldId) {
              toSection.Fields = toSection.Fields.map((item, idx) => {
                return {
                  ...item,
                  i: idx.toString(),
                };
              });
              toSection.Fields.push(generateNewItem(field, toSection.Fields.length));
            }
            return field.fieldGuid !== payload.fieldId;
          });
          return section;
        }
        return section;
      });
    } else {
      state.unrelatedFields = state.unrelatedFields.filter(el => {
        if (el.fieldGuid === payload.fieldId) {
          if (!state.relatedFields) {
            state.relatedFields = [];
          }
          state.relatedFields.push(el.fieldGuid);
          toSection.Fields = toSection.Fields.map((item, idx) => {
            return {
              ...item,
              i: idx.toString(),
            };
          });
          toSection.Fields.push(generateNewItem(el, toSection.Fields.length));
        }
        return el.fieldGuid !== payload.fieldId;
      });
    }
  },
  [DELETE_SECTION](state, uuid) {
    state.data.Sections = state.data.Sections.filter(el => {
      if (el.id.toLowerCase() === uuid.toLowerCase()) {
        el.Fields.forEach(f => {
          state.unrelatedFields.push(state.fields[f.fieldGuid.toLowerCase()]);
        });
      }
      return el.id !== uuid;
    });
  },
  [UPDATE_SECTION](state, payload) {
    const {name, isHidden, styles} = payload;
    const isPlaceholder = name.includes('Placeholder');
    const id = state.customisationsModal.sectionId;
    state.data.Sections = state.data.Sections.map(el => (
      el.id === id
        ? {
          ...el,
          styles,
          isHidden,
          Name: name,
          Placeholder: isPlaceholder,
        }
        : el
    ));
    state.isSettingsWasChanged = true;
  },
  [SET_SECTION_REORDER_MODAL_STATE](state, payload) {
    state.isSectionsReorderModalOpened = payload;
  },
  [SAVE_SECTIONS_ORDERING](state, payload) {
    state.data.Sections = payload;
  },
  [SET_CUSTOMISATION_MODAL_STATE](state, payload) {
    if (payload.isEditMode) {
      const section = state.data.Sections.find(s => s.id === payload.sectionId);
      state.customisationsModal = {
        title: payload.title,
        sectionName: section.Name,
        sectionId: payload.sectionId,
        isOpen: payload.isOpen,
        isEditMode: payload.isEditMode,
      };
    } else {
      state.customisationsModal = payload;
    }
  },
  [SET_SEARCH_VALUE](state, val) {
    state.searchValue = val.toLowerCase();
  },
  [REMOVE_POSTED_STATUS_FROM_RELATED_FIELDS](state) {
    const postedStatusField = Object.values(state.fields).find(el => el.displayName === 'Posted Status');
    state.data.Sections = state.data.Sections.map(section => {
      section.Fields = section.Fields.filter(el => el.fieldGuid !== postedStatusField.fieldGuid);
      return section;
    });
  },
  [UPDATE_MODEL](state, payload) {
    state.item = payload.data;
  },
  [UPDATE_UNRELATED_FIELDS](state, payload) {
    const {mode, data} = payload;

    const setDataToState = (field) => {
      state.fields[field.fieldGuid] = field;
      state.unrelatedFields = state.unrelatedFields.map(el => {
        if (el.fieldGuid === field.fieldGuid) {
          return field;
        }
        return el;
      });
      const isFieldExist = state.unrelatedFields.some(el => el.fieldGuid === field.fieldGuid);
      const isFieldExistInRelated = state.relatedFields
        ? state.relatedFields.some(el => el === field.fieldGuid)
        : false;

      if (!isFieldExist && !isFieldExistInRelated) {
        state.unrelatedFields.push(field);

      }
    };
    switch (mode) {
    case 'add' :
      Array.isArray(data)
        ? data.forEach(el => setDataToState(el))
        : setDataToState(data);
      break;
    case 'delete':
      if (data) {
        delete state.fields[data.fieldGuid];
        state.unrelatedFields = state.unrelatedFields.filter(el => (
          el.fieldGuid !== data.fieldGuid
        ));
      } else {
        state.unrelatedFields = state.unrelatedFields.filter(el => {
          return el.displayName !== 'Posted Status';
        });
      }
    }
  },
  [UPDATE_DATA_IN_EDIT_MODE](state, payload){
    const {field, data, isEditMode} = payload;
    if(isEditMode){
      state.item[field.name] = data;
    }else{
      state.form[field.name] = data;
    }   
  },
};
